import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import icoStar from "src/assets/images/icoStar.svg";
import icoStarActive from "src/assets/images/icoStarActive.svg";
import cn from "classnames";
import styled from "styled-components";
import noFulfill from "src/assets/images/no_fulfill_img.png";
import SVG from "../../utils/SVG";

interface IFulfillItem {
  type?: string;
  data: any;
}

const FulFillShopItem = (props: IFulfillItem) => {
  const navigate = useNavigate();
  const imageServerIp = process.env.REACT_APP_IMAGE_SERVER_IP;
  const [listData, setListData] = useState([]);

  useEffect(() => {
    if (props.data) {
      setListData(props.data.data);
    }
  }, [props.data]);

  const moveToDetail = (execute_yn: string, re_execute_yn: string, execute_idx: string) => {
    if (execute_yn === "Y" || re_execute_yn === "Y") {
      navigate(`/fulfill-detail/` + execute_idx);
    } else {
      alert("아직 이행하지 않은 매장입니다.");
    }
  };

  return (
    <>
      {listData && listData.length > 0 ? (
        <>
          {props.type === "list" ? (
            listData.map((v: any, i: number) => {
              return (
                <TypeItem key={i}>
                  <ShopItemSet onClick={(e) => moveToDetail(v.execute_yn, v.re_execute_yn, v.execute_idx)}>
                    <div className="title">
                      <span className="cate">{v.store_type_name}</span>
                      <span className={cn("name", { dimmed: v.execute_yn === "N" })}>
                        {v.store_name}
                        <span className="userId">{v.store_id}</span>
                        <span className={cn("chat", { new: v.comment_read_yn === "N" })} style={{ marginLeft: "1rem" }}>
                          {v.comment_read_yn === "N" ? (
                            <SVG name="chatActive" width={12.967} height={13.205} viewBox="0 0 12.967 13.205" />
                          ) : (
                            <SVG name="chat" width={12.967} height={13.205} viewBox="0 0 12.967 13.205" />
                          )}
                          {v.comment_count}
                        </span>
                      </span>
                    </div>
                    <div>
                      <>
                        {v.re_execute_yn === "Y" && <span className="remark-re">재이행</span>}
                        {v.score !== null ? (
                          <span className="star-score active">{v.score}</span>
                        ) : v.execute_yn === "Y" ? (
                          <span className="star-score">-</span>
                        ) : (
                          ""
                        )}
                      </>
                    </div>
                  </ShopItemSet>
                </TypeItem>
              );
            })
          ) : (
            <>
              {listData.map((v: any, i: number) => {
                return (
                  <TypeItem key={i}>
                    <ShopItemGridSet onClick={(e) => moveToDetail(v.execute_yn, v.re_execute_yn, v.execute_idx)}>
                      <div className="img-wrap">
                        {v.execute_imgs.length > 0 ? (
                          <img src={imageServerIp + v.execute_imgs[0].img_url} alt="더미이미지" />
                        ) : (
                          <img src={noFulfill} alt="더미이미지" />
                        )}
                        {v.execute_imgs.length > 1 && <span className="extra-img">+{v.execute_imgs.length - 1}</span>}
                        {v.re_execute_yn === "Y" && <span className="remark-re">재이행</span>}
                      </div>
                      <div>
                        <div className="sub-info">
                          <div>
                            <span className="cate">{v.store_type_name}</span>
                          </div>
                          <div>
                            {v.score !== null ? (
                              <span className="star-score active">{v.score}</span>
                            ) : v.execute_yn === "Y" ? (
                              <span className="star-score">-</span>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                        <div style={{ display: "flex", alignItems: "baseline", gap: "1rem" }}>
                          <span className={cn("name", { dimmed: v.execute_yn === "N" && v.re_execute_yn === "N" })}>{v.store_name}</span>
                          <span className={cn("chat", { new: v.comment_read_yn === "N" })}>
                            {v.comment_read_yn === "N" ? (
                              <SVG name="chatActive" width={12.967} height={13.205} viewBox="0 0 12.967 13.205" />
                            ) : (
                              <SVG name="chat" width={12.967} height={13.205} viewBox="0 0 12.967 13.205" />
                            )}
                            {v.comment_count}
                          </span>
                        </div>
                      </div>
                    </ShopItemGridSet>
                  </TypeItem>
                );
              })}
            </>
          )}
        </>
      ) : (
        <NoResult>리스트 결과가 없습니다.</NoResult>
      )}
    </>
  );
};

const TypeItem = styled.li`
  .remark-re {
    display: inline-block;
    padding: 2px 10px;
    margin-right: 8px;
    background-color: ${({ theme }) => theme.color.main};
    color: #fff;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
  }
  .star-score {
    position: relative;
    top: 1px;
    display: inline-block;
    padding-left: 18px;
    font-family: "Poppins";
    line-height: 20px;
    background: url(${icoStar}) no-repeat left 2px;
    &.active {
      background: url(${icoStarActive}) no-repeat left 2px;
    }
  }
`;

const ShopItemSet = styled.div`
  display: inline-block;
  padding: 16px 0;
  border-bottom: 1px solid ${({ theme }) => theme.color.linePrimary};
  ${({ theme }) => theme.flexBox.flexMixin("row", "space-between", "center")}
  > div:last-child {
    flex-shrink: 0;
  }
  .title {
    max-width: 80%;
    flex-grow: 1;
    ${({ theme }) => theme.flexBox.flexMixin("row", "flex-start", "center")}
    .cate {
      flex-shrink: 0;
      display: inline-block;
      padding-right: 8px;
      margin-right: 8px;
      border-right: 2px solid ${({ theme }) => theme.color.lineSecondary};
      color: ${({ theme }) => theme.color.quaternary};
      font-weight: 500;
    }
    .name {
      flex-grow: 1;
      font-weight: 500;
      ${({ theme }) => theme.textOverflow.singleLine()}
      &.dimmed {
        color: ${({ theme }) => theme.color.quaternary};
      }
      .userId {
        position: relative;
        display: inline-block;
        margin-left: 8px;
        color: ${({ theme }) => theme.color.quaternary};
        font-size: 12px;
        font-weight: 400;
      }
    }
    .chat {
      padding-left: 4px;
      flex-shrink: 0;
      color: #747474;
      font-family: "Poppins";
      font-weight: 400;
      &.new {
        color: ${({ theme }) => theme.color.subMain};
      }
      > svg {
        position: relative;
        left: -4px;
        top: -1px;
      }
    }
  }
`;

const ShopItemGridSet = styled.div`
  .img-wrap {
    overflow: hidden;
    position: relative;
    max-width: 100%;
    padding-top: 100%;
    margin-bottom: 16px;
    background: #f4f4f4;
    > img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: inline-block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .remark-re {
      z-index: 10;
      position: absolute;
      top: 8px;
      left: 8px;
    }
    .extra-img {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 48px;
      height: 48px;
      line-height: 48px;
      background: rgba(98, 106, 111, 0.7);
      color: #fff;
      text-align: center;
    }
  }
  .sub-info {
    ${({ theme }) => theme.flexBox.flexMixin("row", "space-between", "center")}
    .cate {
      display: inline-block;
      color: #c4c4c4;
      font-weight: 500;
    }
  }
  .name {
    margin-top: 5px;
    font-weight: 500;
    ${({ theme }) => theme.textOverflow.singleLine()}
    &.dimmed {
      color: ${({ theme }) => theme.color.quaternary};
    }
  }
  .chat {
    flex-shrink: 0;
    color: #747474;
    font-family: "Poppins";
    font-weight: 400;
    &.new {
      color: ${({ theme }) => theme.color.subMain};
    }
    > svg {
      position: relative;
      left: -4px;
      top: -1px;
    }
  }
`;

const NoResult = styled.li`
  width: 100% !important;
  margin: 80px 0 40px;
  text-align: center;
`;

export default FulFillShopItem;
